import { motion } from "framer-motion";
import { PROCESS, STATS, revealUp } from "../../lib/mrs";

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#0a0b0a] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
        <div className="lg:col-span-7">
          <motion.p
            variants={revealUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#b89b72] mb-5"
          >
            How We Work
          </motion.p>
          <motion.h2
            variants={revealUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="font-display font-light text-[#eae7e0] leading-[1.05] text-4xl md:text-5xl lg:text-6xl tracking-tight mb-14 max-w-xl"
          >
            From your first call to a space that breathes.
          </motion.h2>

          <div className="border-t border-[#eae7e0]/10">
            {PROCESS.map((p, i) => (
              <motion.div
                key={p.no}
                variants={revealUp}
                custom={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                data-testid={`process-step-${i}`}
                className="group flex items-start gap-6 md:gap-10 border-b border-[#eae7e0]/10 py-7 transition-colors duration-500 hover:bg-[#121412]/60 px-2 -mx-2"
              >
                <span className="font-num text-[#b89b72] text-lg md:text-xl pt-1">
                  {p.no}
                </span>
                <div className="flex-1">
                  <h3 className="font-display text-2xl md:text-3xl font-normal text-[#eae7e0] transition-transform duration-500 group-hover:translate-x-1">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm md:text-base text-[#9ca399] leading-relaxed max-w-lg">
                    {p.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 lg:pl-8 lg:border-l lg:border-[#eae7e0]/10">
          <div className="grid grid-cols-2 gap-y-12 gap-x-6 lg:sticky lg:top-28">
            {STATS.map((s, i) => (
              <motion.div
                key={i}
                variants={revealUp}
                custom={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                data-testid={`stat-${i}`}
              >
                <div className="font-num font-light text-[#eae7e0] text-5xl md:text-6xl leading-none tracking-tight">
                  {s.value}
                  {s.unit && (
                    <span className="font-num text-2xl md:text-3xl text-[#b89b72] ml-1">
                      {s.unit}
                    </span>
                  )}
                </div>
                <p className="mt-3 text-xs md:text-sm tracking-wide text-[#9ca399] uppercase">
                  {s.label}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
